import api from '@http/api';

export interface IContatoOffline {
  contato_offline_id: string;
  cidade_id: string;
  estado_id: string;
  estado_descricao: string;
  cidade_descricao: string;

}

interface IResponsePerfil {
  error: boolean;
  response?: IPerfils;
}

export interface IPerfils {
  contato_offline: IContatoOffline;

}

interface IResponsePessoa {
  error: boolean;
  response?: IPessoa;
}

export interface IPessoa {
  nome_pessoa: string;

}

export interface IGetAllTipoIntencao{
  id: number;
  descricao: string;

}

export interface IRequestCreateIntencao{
  descricao: string;
  nome_completo: string;
  data_intencao_inicio: string,
  data_intencao_fim: string,
  id_perfil: number,
  id_cidade: number;
  id_estado: number;
  id_tipo_solicitacao: number;
  id_tipo_intencao_missa: number;
}

class Services {

  public async CreateIntencao(data: IRequestCreateIntencao) {
    return await api
      .post('/api/IntencaoMissa/CreateIntencao', data)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async GetPessoaByID(id_perfil: any): Promise<IResponsePessoa> {
    return await api
      .get<IPessoa>(`api/Triagem/PegaInformacoesFixasCadastro?id_perfil=${id_perfil}`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };

      })
      .catch(error => {
        return {
          error: true,
        };
      });

  }

  public async GetPerfilByID({ id }: any): Promise<IResponsePerfil> {
    return await api
      .get<IPerfils>(`api/Perfil/GetPerfilById/${id}`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };

      })
      .catch(error => {
        return {
          error: true,
        };
      });

  }


  public async GetAllTipoIntencao() {
    return await api
      .get<IGetAllTipoIntencao[]>(`/api/TipoIntencaoMissa/GetAllTipoIntencaoMissa`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

}

export default Services;
